var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import Edelicon from "@frameworks/web/components/generic/Edelicon";
import GenericTooltip from "@frameworks/web/components/generic/GenericTooltip";
import React, { useState, useRef, useEffect } from "react";
import "@frameworks/shared-library/stylesheets/components/OrderBookSideBar/OrderBookSideBar.scss";
import { nanoid } from "nanoid";
import helpDeskDi from "@mainDi/features/helpDesk/servicelocator";
export var EContactDetailsFor;
(function (EContactDetailsFor) {
    EContactDetailsFor["RM"] = "RM";
    EContactDetailsFor["client"] = "client";
    EContactDetailsFor["helpDesk"] = "helpDesk";
})(EContactDetailsFor || (EContactDetailsFor = {}));
var OrderBookSideBarNeedHelp = function (props) {
    var uniqueIdForNeedHelpContainer = nanoid();
    var buttonRef = useRef(null);
    var _a = __read(useState(false), 2), showTooltip = _a[0], setShowTooltip = _a[1];
    var _b = __read(useState({
        email: "",
        phoneNumber: "",
    }), 2), contactDetails = _b[0], setContactDetails = _b[1];
    var handleOnCloseIcon = function () {
        setShowTooltip(false);
    };
    var hanldleOnClickEmail = function () {
        var mailtoLink = "mailto:".concat(contactDetails.email);
        window.location.href = mailtoLink;
    };
    var handleOnClickPhone = function () {
        // Construct the tel URL
        var telLink = "tel:".concat(contactDetails.phoneNumber);
        // Open the tel link to initiate a call
        window.location.href = telLink;
    };
    var getClientDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        var data, email, phoneNumber, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, helpDeskDi.mfHelpDesk.getMfClientContact({
                            clientCode: props === null || props === void 0 ? void 0 : props.clientCode,
                        })];
                case 1:
                    data = (_a.sent()).data;
                    if (data) {
                        email = "";
                        phoneNumber = "";
                        switch (props.contactDetailsFor) {
                            case EContactDetailsFor.RM: {
                                email = data.rmEmail;
                                phoneNumber = data.rmMobile;
                                break;
                            }
                            case EContactDetailsFor.client: {
                                email = data.clientEmail;
                                phoneNumber = data.clientMobile;
                                break;
                            }
                            case EContactDetailsFor.helpDesk: {
                                email = data.helpdeskEmail;
                                phoneNumber = data.helpdeskNumber;
                                break;
                            }
                            default: {
                                email = data.helpdeskEmail;
                                phoneNumber = data.helpdeskNumber;
                                break;
                            }
                        }
                        setContactDetails(__assign(__assign({}, contactDetails), { email: email, phoneNumber: phoneNumber }));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    console.log("err", err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        // added this to handle the click event on the button div inside GenericTooltip component
        var handleClick = function () {
            setShowTooltip(function () { return true; });
        };
        var divElement = buttonRef.current;
        divElement === null || divElement === void 0 ? void 0 : divElement.addEventListener("click", handleClick);
        getClientDetails();
        return function () {
            divElement === null || divElement === void 0 ? void 0 : divElement.removeEventListener("click", handleClick);
        };
    }, []);
    return (React.createElement("div", { className: "d-flex flex-row primary-need-help-container hand_cursor", id: uniqueIdForNeedHelpContainer },
        React.createElement(GenericTooltip, { container: function () { return document.getElementById(uniqueIdForNeedHelpContainer); }, toolTipClassName: "need-help-tooltip", placement: "top", triggerType: "click", externalClassName: "remove-btn-props", showTooltip: showTooltip, hasOuterShowState: true, toolTipText: React.createElement("div", { className: "d-flex flex-column gap-3" },
                React.createElement("div", { className: "d-flex justify-content-between need-help-header" },
                    React.createElement("label", { className: "DMsanR_11_400 text-decoration-underline" }, "Contact us"),
                    React.createElement("span", { onClick: handleOnCloseIcon },
                        React.createElement("i", { className: "edel-icon-cross-bold-small" }))),
                React.createElement("div", { className: "d-flex flex-column align-items-start gap-2" },
                    React.createElement("div", { role: "button", onClick: hanldleOnClickEmail, className: "d-flex align-items-center justify-content-center gap-2 hand_cursor" },
                        React.createElement(Edelicon, { className: "edel-icon-email-color", paths: 4 }),
                        React.createElement("label", { className: "DMSansNormal_12_400 text-decoration-underline hand_cursor" }, contactDetails.email)),
                    React.createElement("div", { role: "button", onClick: handleOnClickPhone, className: "d-flex align-items-center justify-content-center gap-2 hand_cursor" },
                        React.createElement(Edelicon, { className: "edel-icon-contact", paths: 3 }),
                        React.createElement("label", { className: "DMSansNormal_12_400 hand_cursor" }, contactDetails.phoneNumber)))), noButton: true, button: React.createElement("div", { ref: buttonRef, className: "need-help d-flex align-items-center gap-2" },
                React.createElement(Edelicon, { className: "edel-icon-chat-colored", paths: 4 }),
                React.createElement("label", { className: "DMSansNormal_12_400 text-decoration-underline hand_cursor" }, "Need Help?")) })));
};
export default OrderBookSideBarNeedHelp;
